module.exports = __webpack_public_path__ + "img/ic_survey.bbb407d4.svg";